import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthentificationService} from "../services/authentification.service";


@Injectable({
    providedIn: 'root'
})

export class AuthGuard  {


    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const componentPath = next.routeConfig.path;
        if (!this.authService.isAutheticated()) {
            this.route.navigateByUrl('/login');
            return false;
        } else if (!this.canAccess(componentPath)) {
            this.route.navigateByUrl('/forbidden');
            return false;
        }
        return true;
    }

    constructor(private route: Router,
                private authService: AuthentificationService) {
    }


    private canAccess(componentPath: string): boolean {
        if (this.authService.isAdmin()) {
            return true;
        } else {
            return componentPath === 'offers' || componentPath === 'dashboard';
        }
    }

}
